// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"78":"4848356f","151":"c056e555"}[chunkId] + ".css";
};